import { axiosWithAuth } from "helpers";
import { TidTabs } from "types";

export const tidEquipmentQueueService = {
	getList,
	getAssignedTo,
	assignToUser,
	claimAssigned,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getAssignedTo(pattern, page, showInactive = false) {
	const body = {
		pattern,
		page,
		pageSize: 20,
		showInactive,
	};

	const options = {
		method: "POST",
		data: body,
		url: `${API_URL}/api/applications/equipment_queue/users`,
	};

	return axiosWithAuth(options);
}

function getList({ page, sortBy, filters, tabName }) {
	let tab = tabName;
	if (tabName === TidTabs.InProgress.name) {
		tab = "in_progress";
	} else if (tabName === TidTabs.Complete.name) {
		tab = "completed";
	}
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.id ? sortBy?.id : undefined,
			ascending: sortBy?.id ? sortBy?.desc : undefined,
			mid: filters?.mid,
			merchant_name: filters?.merchantName,
			number: filters?.number,
			agent_office: filters?.agentOffice,
			agent_name: filters?.agentName,
			terminal_number: filters?.terminalNumber,
			manufacturer_id: filters?.manufacturerId,
			model_id: filters?.modelId,
			equipment_assignee_id: filters?.assignedTo?.id,
			pended_to_id: filters?.pendedTo?.id,
			pend_status: filters?.pendStatus?.name,
			auto_tid_status: filters?.autoTidStatus?.name,
		},
		url: `${API_URL}/api/applications/equipment_queue/${tab}`,
	};

	return axiosWithAuth(options);
}

function claimAssigned(applicationId, claimName) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/equipment_queue/${applicationId}/${claimName}`,
	};

	return axiosWithAuth(options);
}

function assignToUser(applicationId, assigneeId) {
	const options = {
		method: "POST",
		url: `${API_URL}/api/applications/equipment_queue/${applicationId}/assign_to/${assigneeId}`,
	};

	return axiosWithAuth(options);
}
